<div class="tier-limits-indicator" *ngIf="usageStats$ | async as stats">
  <div class="limits-container">
    <div class="limit-header" *ngIf="limitType === 'ddq'">
      <div class="header-content">
        <mat-icon class="limit-icon">bar_chart</mat-icon>
        <span class="limit-title">{{ 'INTL_USAGE_LIMITS' | translate }}: {{ 'INTL_DDQ_RUNS' | translate }}</span>
      </div>
    </div>

    <div class="limit-content">
      <!-- DDQ Runs Limit Chart -->
      <div class="limit-chart-card" *ngIf="limitType === 'ddq'">
        <!-- Visual Bar Chart -->
        <div class="chart-visualization" *ngIf="!(isUnlimited$ | async)">
          <div class="bar-chart-container">
            <div class="bar-wrapper">
              <div class="bar-fill" [style.width.%]="getUsagePercentage(stats)"
                [class.warning]="getUsagePercentage(stats) > 80" [class.critical]="getUsagePercentage(stats) > 95">
                <div class="bar-value">{{ stats.ddqRunsThisMonth }}</div>
              </div>
              <div class="bar-total">{{ getTotalLimit(stats) }}</div>
            </div>
            <div class="bar-labels">
              <span class="bar-label-start">0</span>
              <span class="bar-label-end">{{ getTotalLimit(stats) }}</span>
            </div>
          </div>
        </div>

        <!-- Unlimited Indicator -->
        <div class="unlimited-indicator" *ngIf="isUnlimited$ | async">
          <div class="unlimited-bar">
            <div class="unlimited-fill" [style.width.%]="getUnlimitedFillWidth(stats)">
            </div>
            <div class="unlimited-text-right">{{ stats.ddqRunsThisMonth }} / {{ 'INTL_UNLIMITED' | translate }}</div>
          </div>
          <div class="unlimited-note">
            <mat-icon>infinity</mat-icon>
            <span>{{ 'INTL_UNLIMITED_USAGE' | translate }}</span>
          </div>
        </div>

        <!-- Trial Period Note -->
        <div class="trial-badge" *ngIf="isTrialPeriod$ | async">
          <mat-icon>schedule</mat-icon>
          <span>{{ 'INTL_UNLIMITED_DURING_TRIAL' | translate }}</span>
        </div>

        <!-- Remaining Count -->
        <div class="remaining-info" *ngIf="!(isUnlimited$ | async) && !(isTrialPeriod$ | async)">
          <mat-icon class="remaining-icon">check_circle</mat-icon>
          <span>{{ stats.remainingDdqRuns }} {{ 'INTL_REMAINING_THIS_MONTH' | translate }}</span>
        </div>
      </div>

      <!-- IM Generations Limit Chart -->
      <div class="limit-chart-card" *ngIf="limitType === 'im'">
        <div class="chart-header">
          <div class="chart-title">
            <mat-icon class="chart-icon">image</mat-icon>
            <span>{{ 'INTL_IM_GENERATIONS' | translate }}</span>
          </div>
          <div class="chart-stats">
            <div class="stat-item">
              <span class="stat-value">{{ stats.imGenerationsTotal }}</span>
              <span class="stat-label">{{ 'INTL_TOTAL' | translate }}</span>
            </div>
          </div>
        </div>
        <div class="im-visualization">
          <div class="im-count-display">
            <mat-icon class="im-icon">image</mat-icon>
            <span class="im-number">{{ stats.imGenerationsTotal }}</span>
            <span class="im-label">{{ 'INTL_GENERATIONS' | translate }}</span>
          </div>
        </div>
      </div>

      <!-- Tier Comparison Section -->
      <div class="tier-comparison" *ngIf="showTierComparison && limitType === 'ddq'">
        <div class="comparison-header">
          <mat-icon>compare_arrows</mat-icon>
          <span>{{ 'INTL_COMPARE_TIERS' | translate }}</span>
        </div>
        <div class="comparison-chart">
          <div class="tier-bar" *ngFor="let tier of tierLimits"
            [class.current-tier]="(currentTierCode$ | async) === tier.code">
            <div class="tier-bar-label">
              <span class="tier-name">{{ tier.name }}</span>
              <mat-icon *ngIf="(currentTierCode$ | async) === tier.code" class="current-badge">check_circle</mat-icon>
            </div>
            <div class="tier-bar-visual">
              <div class="tier-limit-bar" [style.width.%]="getTierLimitPercentage(tier.limit)">
                <span class="tier-limit-value">{{ tier.limit === 0 ? '∞' : tier.limit }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>